import React from 'react';

import { useListingSelectors } from '@kamernet/modules/Listing/context/hooks/useListingSelectors';
import { ListingsContext } from '@kamernet/modules/Listing/context/ListingsContext';

import { ContentCity } from './ContentCity';
import { ContentCityGenericSkeleton } from './ContentCityGenericSkeleton';
import { ContentCountry } from './ContentCountry';
import { ContentStreet } from './ContentStreet';

export const Content = () => {
  const isLoading = useListingSelectors().isLoading();
  const { listingsState } = ListingsContext.useContext();
  const { filters } = listingsState.filterResult;
  const { cityName } = filters.location || {};
  const { streetName } = filters;
  const listingTypeIds = filters.listingTypeIds || [];

  if (isLoading) {
    return <ContentCityGenericSkeleton />;
  }

  if (streetName && cityName) {
    return (
      <ContentStreet
        streetName={streetName}
        cityName={cityName}
        listingTypeIds={listingTypeIds}
      />
    );
  }

  if (cityName) {
    return <ContentCity cityName={cityName} listingTypeIds={listingTypeIds} />;
  }

  return <ContentCountry listingTypeIds={listingTypeIds} />;
};
